'use strict';





export default function setupElmElement (config) {
    const {selector, moduleName, formatFlags} = config;

    if ( window.Elm && window.Elm[moduleName] ) {
        const elem = document.querySelector(selector);

        if ( elem ) {
            const flags = formatFlags ? formatFlags(elem.dataset, elem) : null;

            const module = window.Elm[moduleName].init({
                node: elem,
                flags: flags,
            });

            if ( config.ports ) {
                Object.keys(config.ports).forEach(name => {
                    if ( module.ports[name] ) {
                        module.ports[name].subscribe(config.ports[name]);
                    }
                });
            }

            if ( config.subscriptions ) {
                Object.keys(config.subscriptions).forEach(name => {
                    if ( module.ports[name] ) {
                        module.ports[name]
                            .send(config.subscriptions[name]());
                    }
                });
            }

            if ( config.construct ) {
                config.construct(module);
            }
        }
    }
}
